<template>
  <div class="play-video-container" :class="{'mobile-play-video-container':isMobile}">


    <div class="video">
      <!--autoplay 自动播放-->
      <video v-show="!isLoadSection && canStudyCourse" controlslist="nodownload" ref='videoRef' width="100%"
             height="100%" controls
			:options="playerOptions">
        <source :src="fileUrl">
        您的浏览器不支持 video 标签。
      </video>

      <div v-show="isLoadSection" :style="isMobile?{height:'200px'}:{}">
        <loading/>
      </div>

      <div v-show="!isLoadSection && !canStudyCourse" class="no-text">
        <div class="not-permission-text">抱歉，您无法观看该章节内容。</div>
      </div>
    </div>
    <div v-if="!isMobile" class="section">
      <div v-for="(section,sectionNum) in courseInfo.sections" :key="section.sectionId">
        <div class="section-title"> {{ section.sectionName }}</div>
        <ul>
          <li v-for="(subSection,subSectionNum) in section.subSections" :key="subSection.sectionId"
              @click="playVideo(subSection.sectionId,subSection.canTry)"
              :class="{'active-section':selectedSection.sectionId===subSection.sectionId}">
            <div class="section-name">
              <span>录播</span>
              {{ sectionNum + 1 }}-{{ subSectionNum + 1 }}
              <span style="margin-left: 5px">
                                {{ subSection.sectionName }}
                            </span>
            </div>
            <div class="section-time" v-if="subSection.file">
              {{ subSection.file.duration | formatDurationMinute }}
            </div>
          </li>
          <hr style="margin:0;height:1px;border:0;background-color:#6A6A6A;color:#6A6A6A;"/>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import {DISPATCH_SWITCH_SECTION} from "@constants/action-type/course-action-type";
import common from "../../../mixin/common";
import Loading from "@components/loading/Loading";
import {changeProgress} from "@api/courese-detail"
import {SUCCESS} from "@constants/code";
import {COMMIT_CHANGE_CURRENT_TIME} from "@constants/mutation-type/course-mutation-type";

const {mapState} = createNamespacedHelpers('course');

export default {
  name: "CoursePlay",
  mixins: [common],
  components: {
    Loading
  },
  data(){
	return{
		playerOptions:{
			// 视频倍速播放
			playbackRates: [0.7, 1.0, 1.5, 2.0],
		}
	}
  },
  mounted() {
    this.$refs.videoRef.onended = () => {
      //    播放结束，传值2，更改学习进度
      if (this.isLogin && this.selectedSection.sectionId) {
        changeProgress(this.$refs.videoRef.currentTime, this.selectedSection.sectionId, false, 2).then((res) => {
          if (res.code !== SUCCESS) {
            console.error(res.msg)
          }
        });
      }
    }

    this.$refs.videoRef.addEventListener("timeupdate", () => {
      // 修改vuex中的currentTime
      this.$store.commit(COMMIT_CHANGE_CURRENT_TIME, {currentTime: this.$refs.videoRef.currentTime})
    }, false);
  },
  beforeDestroy() {
    //组件销毁前记录状态
    if (this.isLogin && this.selectedSection.sectionId) {
      changeProgress(this.$refs.videoRef.currentTime, this.selectedSection.sectionId, false, false).then((res) => {
        if (res.code !== SUCCESS) {
          console.error(res.msg)
        }
      });
    }
    this.$store.commit(COMMIT_CHANGE_CURRENT_TIME, {currentTime: 0})
  },
  methods: {
    playVideo(sectionId, canTry) {
      if (this.$func.isTrue(this.courseInfo.isFree) || this.isLoginClick()) {
        this.$store.dispatch(DISPATCH_SWITCH_SECTION, {
          sectionId,
          canTry,
          currentTime: this.$refs.videoRef.currentTime
        })
      }
    }
  },
  computed: {
    fileUrl() {
      if (this.selectedSection.file)
        return this.selectedSection.file.fileUrl;
      else
        return ''
    },
    ...mapState({
      selectedSection: 'selectedSection',
      courseInfo: 'courseInfo',
      isLoadSection: 'isLoadSection',
      canStudyCourse: 'canStudyCourse'
    }),
  },
  watch: {
    selectedSection() {
      if (this.selectedSection.file) {
        this.$refs.videoRef.src = this.selectedSection.file.fileUrl;
        this.$refs.videoRef.currentTime = this.selectedSection.sectionStudyLearnTime;
      }
    },
  }
}
</script>

<style scoped lang="less">
/*隐藏下载*/
video::-internal-media-controls-download-button {
  display: none;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}


.play-video-container {
  height: 500px;
  background: #232323;

  .video {
    display: inline-block;
    width: 860px;
    height: 500px;
    overflow: hidden;
    /*background: url("../assets/img/null.png") center no-repeat ;*/
    background-size: 900px 500px;
    border: 1px solid black;

    > div {
      height: 100%;
      width: 100%;
      overflow: hidden;
      position: relative;
    }

    .not-permission-text {
      position: absolute;
      width: 100%;
      top: 50%;
      color: white;
      text-align: center;
    }
  }

  .section {
    display: inline-block;
    width: 300px;
    height: 500px;
    overflow: auto;
    background: #131313;
    color: #999999;
    padding: 20px;

    .section-title {
      font-size: 18px;
      margin: 16px 0;
    }

    li {
      margin: 10px 0;
      cursor: pointer;

      .section-name {
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
      }

      .section-time {
        text-indent: 44px;
      }
    }

    li:hover {
      color: #00CF8C;

      span:nth-of-type(1) {
        /*color: #00CF8C;*/
        background-color: #00CF8C;
      }
    }

    span:nth-of-type(1) {
      display: inline-block;
      font-size: 12px;
      /*width: 40px;*/
      /*height: 16px;*/
      line-height: 16px;
      padding: 1px 8px 2px 8px;
      color: white;
      text-align: center;
      background: #999999;
      border-radius: 2px;
    }
  }

  /*滚动条样式*/

  .section::-webkit-scrollbar { /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
    width: 10px;
    height: 10px;
  }

  /*控制整个滚动条*/

  ::-webkit-scrollbar {
    background-color: lightgray;
    background-color: black;
    width: 10px;
    height: 10px;
    background-clip: padding-box;
  }

  /*滚动条两端方向按钮*/

  ::-webkit-scrollbar-button {
    /*background-color: pink;*/
    display: none;
  }

  /*滚动条中间滑动部分*/

  ::-webkit-scrollbar-thumb {
    background-color: #888888;
    border-radius: 4px;
  }

  /*滚动条右下角区域*/

  ::-webkit-scrollbar-corner {
    /*background-color: red;*/
    display: none;
  }
}

.mobile-play-video-container {
  height: auto;

  .video {
    width: 100%;
    height: auto;

    .no-text {
      width: 100%;
      height: 200px;
      text-align: center;
      color: red;
    }
  }

  .mobile-loading {
    height: 200px;
  }

}

</style>
